import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

const HERO_IMG =
  "https://cdn.prod.website-files.com/68cfd6257a8e7e88b64434d7/68e2cafe4ba9479900426d39_woman%20on%20terrainhopper-2-c.webp";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero"
      className="relative min-h-[100svh] w-full overflow-hidden grain pt-16"
    >
      <img
        src={HERO_IMG}
        alt="Rider on the TerrainHopper Overlander off-road mobility vehicle"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/55 to-black/85" />
      <div className="absolute inset-x-0 top-24 overflow-hidden pointer-events-none">
        <div className="dust-line h-px w-1/3 bg-primary/70" />
      </div>

      <div className="relative z-10 mx-auto max-w-7xl px-6 lg:px-10 h-full flex flex-col justify-end pb-16 lg:pb-24 min-h-[100svh]">
        <div className="max-w-4xl fade-up">
          <span
            data-testid="hero-eyebrow"
            className="inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.3em] text-primary-foreground bg-primary/90 px-3 py-1.5 rounded-sm"
          >
            <ArrowRight className="h-3 w-3" /> Authorised Australian distributor of TerrainHopper
          </span>
          <h1
            data-testid="hero-title"
            className="font-display mt-6 text-white text-5xl sm:text-6xl lg:text-8xl uppercase tracking-tighter font-black leading-[0.9]"
          >
            <span className="text-primary">Overlander.</span><br />
            Join the<br />
            adventure again.
          </h1>
          <p
            data-testid="hero-subtitle"
            className="mt-6 max-w-2xl text-white/90 text-base md:text-lg leading-relaxed"
          >
            A range of Australian-ready off-road mobility vehicles and Class 3 wheelchairs. From
            the footpath home to the red centre — pick the Overlander that fits how you roam.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <Button
              asChild
              size="lg"
              data-testid="hero-quote-btn"
              className="rounded-sm uppercase tracking-wider font-bold px-8 py-6 text-sm group"
            >
              <a href="#models">
                Compare Models
                <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
              </a>
            </Button>
            <Button
              asChild
              size="lg"
              variant="outline"
              data-testid="hero-watch-btn"
              className="rounded-sm uppercase tracking-wider font-bold px-8 py-6 text-sm bg-transparent border-white/40 text-white hover:bg-white hover:text-foreground"
            >
              <a href="#videos">See it in Action</a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
